import { createAction } from 'redux-actions';
export const fetchFreshDeviations = createAction(`EDITOR.FETCH_FRESH_DEVIATIONS`, ({ deviationIds , setEntityData  })=>({
        deviationIds,
        setEntityData
    }));
